import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  font-size: 3rem;
  margin: 0;
  font-weight: 600;
`;

export const Description = styled.h2`
  font-weight: 400;
  width: 100%;
  text-align: center;
  margin: 0;
  font-size: 2rem;
`;
